/** Hell/Dunkel/Automatisch je Geraet (tokens.css: data-theme setzt color-scheme). */

export type Modus = "system" | "light" | "dark";

export function darstellungLesen(): Modus {
  try {
    const wert = localStorage.getItem("darstellung");
    return wert === "light" || wert === "dark" ? wert : "system";
  } catch {
    return "system";
  }
}

/** Setzt data-theme an <html> (tokens.css: color-scheme); „system“ folgt dem Geraet. */
export function darstellungAnwenden(modus: Modus = darstellungLesen()) {
  if (modus === "system") document.documentElement.removeAttribute("data-theme");
  else document.documentElement.setAttribute("data-theme", modus);
}

